import EwaybillDTO from "@/dto/order/EwaybillDTO";
import WaybillTemplateDTO from "@/dto/template/WaybillTemplateDTO";
import EwaybillType from "@/enum/EwaybillType";
import WaybillTemplatePrintType from "@/enum/WaybillTemplatePrintType";
import GlobalStore from "@/store";
import { GetPrintDataParams } from "./type";

/** 构建获取旧单号接口的参数 */
export async function buildPrintDataApiParams(
    shopId: number,
    ewaybill: EwaybillDTO,
    waybillTemplate: WaybillTemplateDTO,
    globalStore: typeof GlobalStore,
) {
    await globalStore.ewaybillAccountStore.ensure();

    const ewaybillShippingAddressIds = [];
    const params: GetPrintDataParams = {
        shopId,
        ewaybillId: ewaybill.id,
    };

    const { ewaybillAccountMapping } = globalStore.ewaybillAccountStore;
    const JinRiTeMaiEwaybillTypes = [
        EwaybillType.JINRITEMAI,
        EwaybillType.JINRITEMAI_SHARE,
        EwaybillType.JINRITEMAI_SHOP_AUTH,
        EwaybillType.JINRITEMAI_IOP,
        EwaybillType.JINRITEMAI_AUTH,
        EwaybillType.JINRITEMAI_AUTH_SHARE,
        EwaybillType.JINRITEMAI_SUPPLIER,
    ];

    if (JinRiTeMaiEwaybillTypes.includes(ewaybill.type) || waybillTemplate.printType === WaybillTemplatePrintType.SF) {
        const ewaybillAccount = ewaybillAccountMapping.get(waybillTemplate.ewaybillShippingAddressId);

        if (!ewaybillAccount) {
            throw new Error("该快递单模板对应的电子面单账号已被删除，请重新选择快递单模板");
        } else {
            ewaybillAccount.subscriptions.forEach((subscription) => {
                subscription.branchAccounts.forEach((branchAccount) => {
                    branchAccount.shippingAddresses.forEach((shippingAddress) => {
                        ewaybillShippingAddressIds.push(shippingAddress.id);
                    });
                });
            });

            params.ewaybillAccount = {
                id: ewaybillAccount.id,
                shopId: ewaybillAccount.shopId,
                type: ewaybillAccount.type,
                platformUsername: ewaybillAccount.platformUsername,
                ewaybillShippingAddressIds,
                name: ewaybillAccount.name,
            };

            params.waybillTemplate = {
                logisticsCompany: waybillTemplate.logisticsCompany,
            };
        }
    }

    if (waybillTemplate.printType === WaybillTemplatePrintType.SF) {
        params.isSfPrintType = true;
    }

    return params;
}
